@if (isEmbedded) {
  <main class="app-wrapper">
    <router-outlet></router-outlet>
  </main>
} @else {
  <main class="app-wrapper">
    <div class="router-wrapper">
      <router-outlet></router-outlet>
    </div>
    <sharry-bottom-bar></sharry-bottom-bar>
  </main>
  @defer (on idle) {
    @if (splashScreenService.showSplash$ | async; as showSplash) {
      @if (showSplash !== 'destroyed') {
        <sharry-splash-screen [ngClass]="{ 'hidden-splash': showSplash === 'hidden' }"> </sharry-splash-screen>
      }
    }
  }
}
